export default __webpack_public_path__ + "static/media/collision-theory.87ea9ec5.png";